import { render, staticRenderFns } from "./PropertyFormRecordType.vue?vue&type=template&id=48445338&scoped=true&"
import script from "./PropertyFormRecordType.vue?vue&type=script&lang=ts&"
export * from "./PropertyFormRecordType.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyFormRecordType.vue?vue&type=style&index=0&id=48445338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48445338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
